"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtensionIntegration = void 0;
var ExtensionIntegration;
(function (ExtensionIntegration) {
    ExtensionIntegration["BROWSER"] = "BROWSER";
    ExtensionIntegration["OUTLOOK"] = "OUTLOOK";
})(ExtensionIntegration = exports.ExtensionIntegration || (exports.ExtensionIntegration = {}));
